import { UID } from 'react-uid';
import React from 'react';
import StyledTooltip from './styles';

const Tooltip = ({ children, tip }) => (
  <UID>
    {(uid) => (
      <StyledTooltip data-testid="styled-tooltip">
        <span
          role="button"
          tabIndex={0}
          aria-describedby={`tooltip-${uid}`}
          onMouseDown={(e) => e.preventDefault()}
          onTouchStart={(e) => e.target.focus()}
        >
          {children}
        </span>
        <div id={`tooltip-${uid}`} role="tooltip">
          <div>{tip}</div>
        </div>
      </StyledTooltip>
    )}
  </UID>
);

export default Tooltip;
